<template>
  <v-menu>
    <template #activator="{ props }">
      <div class="d-inline-flex align-center user-data" v-bind="props">
        <div class="profile-username d-none d-md-block">{{ userStore.name }}</div>
        <img class="profile-image" :src="`/v2/images/emojis/${userEmoji}.png`" width="32" height="32" />

        <v-icon class="profile-caret-down-icon" icon="fa-light fa-caret-down" />
      </div>
    </template>

    <v-list flat class="profile-actions pa-0 mt-4">
      <v-list-item class="profile-smartbook-link" @click="sendToSmartBooks">
        <div class="d-flex align-center pt-3 pb-3">
          <div class="soma-logo align-center">
            <span class="d-flex align-center">
              <v-icon icon="custom:somaLogo" :size="40" />
              <p>Soma</p>
            </span>
          </div>
          <v-icon icon="fa-thin fa-angle-right" color="yellowActive" />
        </div>
      </v-list-item>
      <v-divider />
      <v-list-item class="subscription-action section" prepend-icon="fa-light fa-arrow-up" @click="sendToSubscriptions">
        <v-list-item-title>Abonements</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item class="profile-action section" prepend-icon="fa-light fa-user" @click="sendToProfile">
        <v-list-item-title>Profils</v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item class="sign-out-action section" prepend-icon="fa-light fa-sign-out" @click="signOutUser">
        <v-list-item-title>Iziet</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { useUserStore } from "~/stores/userStore"

export default {
  setup() {
    const userStore = useUserStore()
    return {
      userStore,
    }
  },

  data() {
    return {
      userEmoji: "nerd_face",
    }
  },

  computed: {
    config() {
      return useRuntimeConfig()
    },
  },

  methods: {
    sendToSmartBooks() {
      window.location.href = this.config.public.oldFrontendRoot + "viedgramata"
    },

    sendToSubscriptions() {
      window.location.href = this.config.public.oldFrontendRoot + "upgrade"
    },

    sendToProfile() {
      window.location.href = this.config.public.oldFrontendRoot + "edit-profile"
    },

    signOutUser() {
      this.userStore.logout()
    },
  },
}
</script>

<style lang="sass">
.user-data
  cursor: pointer
  gap: 8px

  .profile-caret-down-icon
    width: 13px
    font-size: 20px

.profile-actions
  border: 1px solid lightgrey

.profile-smartbook-link
  h2
    line-height:25px
    margin-top: -8px
  .v-img
    max-width: 24px
</style>
